import {
    GET_STORES_REQUEST,
    GET_STORES_SUCCESS,
    GET_STORES_FAILURE,
    SET_STORE,
    SET_STORES,
    SUBMIT_STORE_REQUEST,
    SUBMIT_STORE_SUCCESS,
    SUBMIT_STORE_FAILURE,
    CREATE_SINGLE_STORE_SUCCESS,
    CREATE_SINGLE_STORE_FAILURE,
    CREATE_SINGLE_STORE_REQUEST
} from '../actions/store';

const initialState = {
    stores: [],
    store: {},
    getFetching: false,
    submitFetching: false,
    testFetching: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_STORES_REQUEST:
            return {
                ...state,
                getFetching: true,
                error: null
            };
        case GET_STORES_SUCCESS:
            return {
                ...state,
                stores: action.payload.stores,
                total: action.payload.total,
                getFetching: false
            };
        case GET_STORES_FAILURE:
            return {
                ...state,
                getFetching: false,
                error: action.error
            };
        case SET_STORE:
            return {
                ...state,
                store: action.payload.store,

            };
        case SET_STORES:
            return {
                ...state,
                stores: action.payload.stores,
            };
        case SUBMIT_STORE_REQUEST:
            return {
                ...state,
                submitFetching: true,

            };
        case SUBMIT_STORE_SUCCESS:
            return {
                ...state,
                submitFetching: false,
            };
        case SUBMIT_STORE_FAILURE:
            return {
                ...state,
                submitFetching: false,
            };
        case CREATE_SINGLE_STORE_REQUEST:
            return {
                ...state,
                submitFetching: true,
            };
        case CREATE_SINGLE_STORE_SUCCESS:
            return {
                ...state,
                submitFetching: false,
            };
        case CREATE_SINGLE_STORE_FAILURE:
            return {
                ...state,
                submitFetching: false,
            };
        default:
            return state;
    }
};
